export const JSON_Bank_Check_Status7 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VVPA28311712855182658FAE",
        "currentStatus":"FOUND",
        "response":{
            "vpa":"vpaaddress@paytm",
            "fullName":"Amit Gupta"
        }
    }
};

export const JSON_Bank_Check_Status8 = {
    "code":"0x0200",
    "message":"Record fetched successfully.",
    "status":"SUCCESS",
    "data":{
        "requestId":"VVPA28311712855182658FAE",
        "currentStatus":"NOT_FOUND"
    }
}

export const JSON_Bank_Check_Status9 = {
    "code": "0x0202",
    "status": "FAILURE",
    "message": "Failure",
    "data":{
            "requestId":"VVPA28311712855182658FAE",
            "currentStatus":"FAILED"
        }
    
}
